/*const backUrl="https://adpsandbox.ir/VenifySDK";*/
const backUrl="/core";
/*const backUrl="http://172.17.17.42:8082";*/
const venifyRoot="/venify"
const veneshRoot="/venesh"
export {backUrl,venifyRoot,veneshRoot}

